import { MBC_MASTRA_API_URL } from "../config/mbc-chat.config";

export async function discardSession(threadId: string): Promise<void> {
  const response = await fetch(
    `${MBC_MASTRA_API_URL}/mbc/threads/${encodeURIComponent(threadId)}`,
    { method: "DELETE" },
  );

  if (!response.ok) throw new Error(`HTTP ${response.status}`);
}
